//
//
//
//
//
//
//

  import iconInside from 'assets/icons/icon-load0@3x.png'
  import iconOutside from 'assets/icons/icon-load1@3x.png'

  export default {
    name: 'loadmoreView',
    props: {
      placeholder: {
        type: String,
        default: '加载中...',
      },
    },
    data: () => ({
      iconOutside,
      iconInside,
    }),
  }



// WEBPACK FOOTER //
// ./client/components/Common/loadmoreView.vue